module.exports = __webpack_public_path__ + "images/category_lp/bike/new/mainView-pc_048a54e94d54807bc53a7ea713adca53.png";